import Axios from "axios";
import { ApiResponse, handleApiErrors } from "..";
import { GlobalSearchParams, GlobalSearchResult } from "./models";

const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}/globalsearch`;
} 

export async function getLocationOverview(params: GlobalSearchParams): Promise<ApiResponse<GlobalSearchResult[]>> {
    return Axios.post<GlobalSearchResult[]>(
        `${baseUrl()}`,
        { ...params.body }
    ).then(res => {return {data: res.data, errorStatus: undefined, errorMessage: undefined}})
    .catch((e) => handleApiErrors<GlobalSearchResult[]>(e));
}